import { Suggestion } from './../../../interfaces/ai';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'rr-insight-control',
  standalone: false,
  templateUrl: './insight-control.component.html',
  styleUrl: './insight-control.component.scss'
})
export class InsightControlComponent {
  @Input() control: FormControl = new FormControl("");
  @Input() headline: { main: string, sub: string } | undefined;
  @Input() placeholder: string = "";
  @Input() options: Suggestion[] = [];
  @Input() suggestions: Suggestion[] = [];

  @Output() nextQuestion = new EventEmitter<void>();
  @Output() suggestOptions = new EventEmitter<void>();
  @Output() addSuggestion = new EventEmitter<Suggestion>();
  @Output() updateSuggestion = new EventEmitter<Suggestion>();
  @Output() deleteSuggestion = new EventEmitter<Suggestion>();

  editmodus: boolean = false;

  manualAddSuggestion(text: string) {
    if (!text || text == "") return;
    let data: Suggestion = { "id": new Date().getTime().toString(), "text": text }
    this.addSuggestion.emit(data)
  }
  manualUpdateSuggestion(suggestionId: string, text: string) {
    this.updateSuggestion.emit({ id: suggestionId, text: text });
  }
  editSuggestion(textarea: HTMLTextAreaElement, div: HTMLDivElement) {
    if (this.editmodus === true) return;
    this.editmodus = true;
    div.classList.add('editing');
    div.classList.remove('disabled');


    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
    textarea.focus();

  }
  saveSuggestion(textarea: HTMLTextAreaElement, div: HTMLDivElement) {
    this.editmodus = false;
    div.classList.remove('editing');
    div.classList.add('disabled');
  }
}
